<nz-badge [nzCount]="unreadCount" [nzOverflowCount]="99">
  <div nz-popover [(nzPopoverVisible)]="popOverVisible"
       (nzPopoverVisibleChange)="onOpen($event)"
       [nzPopoverContent]="contentTemplate"
       nzPopoverTrigger="click"
       nzPopoverPlacement="bottomRight"
       [nzPopoverOverlayClassName]="'notification-popover'"
       [nzPopoverBackdrop]="false">
    <em nz-icon nzType="bell" nzTheme="outline" class="bell-icon" (click)="onClosePopOver()"></em>
  </div>
</nz-badge>

<ng-template #contentTemplate>
  <div class="notification-panel">
    <!-- Header -->
    <div class="notification-header">
      <span class="notification-title">Notification</span>
      <span class="mark-read" (click)="markAllRead()">Mark all as read</span>
    </div>

    <!-- Content -->
    <div class="notification-body" [class.scrollable]="showAll">
      @if (notifications.length === 0) {
        <div class="empty-state">
          <em nz-icon nzType="bell" nzTheme="outline" class="empty-icon"></em>
          <p>No notifications yet</p>
        </div>
      } @else {
        <!-- Today Section -->
        @if (todayNotifications.length > 0) {
          <div class="date-group">Today</div>
          @for (notification of todayNotifications; track notification.id) {
            <div class="notification-item" [class.unread]="!notification.isRead">
              <div class="notification-icon">
                <em nz-icon [nzType]="getNotificationIcon(notification.type)" nzTheme="outline"></em>
              </div>
              <div class="notification-content">
                <p class="notification-item-title">{{ notification.title }}</p>
                <p class="notification-item-time">{{ getTimeDisplay(notification.createdAt) }}</p>
              </div>
            </div>
          }
        }

        <!-- Earlier Section -->
        @if (olderNotifications.length > 0) {
          <div class="date-group">Earlier</div>
          @for (notification of olderNotifications; track notification.id) {
            <div class="notification-item" [class.unread]="!notification.isRead">
              <div class="notification-icon">
                <em nz-icon [nzType]="getNotificationIcon(notification.type)" nzTheme="outline"></em>
              </div>
              <div class="notification-content">
                <p class="notification-item-title">{{ notification.title }}</p>
                <p class="notification-item-time">{{ getTimeDisplay(notification.createdAt) }}</p>
              </div>
            </div>
          }
        }
      }
    </div>

    <!-- View All -->
    @if (hasMoreNotifications) {
      <div class="view-all">
        <button nz-button nzType="link" (click)="toggleShowAll()">View all</button>
      </div>
    }
  </div>
</ng-template>
